import { defineComponent as _defineComponent } from 'vue'
import 
TUIChatEngine,
{
  TUIGlobal,
  TUIStore,
  StoreName,
  TUIGroupService,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import { ref, watch, defineExpose, defineEmits } from "../../../../adapter-vue";
import BottomPopup from "../../../common/BottomPopup/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["onAtListOpen", "insertAt"],
  setup(__props, { expose, emit: emits }) {



const MessageInputAt = ref();
const memberListItems = ref();

const showAtList = ref(false);
const memberList = ref<Array<any>>();
const allMemberList = ref<Array<any>>();
const showMemberList = ref<Array<any>>();
const isGroup = ref(false);
const position = ref({
  left: 0,
  top: 0,
});
const selectedIndex = ref(0);
const isH5 = ref(TUIGlobal.getPlatform() === "h5");
const isPC = ref(TUIGlobal.getPlatform() === "pc");
const currentConversationID = ref("");

const all = {
  userID: TUIChatEngine.TYPES.MSG_AT_ALL,
  nick: "所有人",
  isAll: true,
  avatar: "https://web.sdk.qcloud.com/im/assets/images/at.svg",
};

// todo: 此处后续优化为TUIStore cutomStore中进行存储，避免数据在两个文件中重复监听
TUIStore.watch(StoreName.CONV, {
  currentConversationID: (id: string) => {
    if (id !== currentConversationID.value) {
      currentConversationID.value = id;
      if (currentConversationID?.value?.startsWith("GROUP")) {
        isGroup.value = true;
        const groupID = currentConversationID?.value?.substring(5);
        TUIGroupService.getGroupMemberList({
          groupID,
        }).then((res: any) => {
          memberList.value = res?.data?.memberList;
          allMemberList.value = [all, ...memberList.value];
          showMemberList.value = allMemberList.value;
        });
      } else {
        memberList.value = [];
        allMemberList.value = [];
        showMemberList.value = [];
        isGroup.value = false;
      }
    }
  },
});

const toggleAtList = (show: boolean) => {
  if (!isGroup.value) {
    return;
  }
  showAtList.value = show;
  if (showAtList.value) {
    emits("onAtListOpen");
  }
};
const handleAtListPosition = (positionData: { top: number; left: number }) => {
  position.value = positionData;
};
const setCurrentSelectIndex = (index: any) => {
  selectedIndex.value = index;
  memberListItems?.value[selectedIndex.value]?.scrollIntoView(false);
};
const setShowMemberList = (list: any) => {
  showMemberList.value = list;
};

TUIGlobal.toggleAtList = toggleAtList;
TUIGlobal.handleAtListPosition = handleAtListPosition;
TUIGlobal.setCurrentSelectIndex = setCurrentSelectIndex;
TUIGlobal.setShowMemberList = setShowMemberList;

expose({
  toggleAtList,
});

watch(
  () => [position.value, MessageInputAt?.value],
  () => {
    if (isH5.value || !MessageInputAt?.value || !MessageInputAt?.value?.style) {
      return;
    }
    MessageInputAt.value.style.left = position.value.left + "px";
    MessageInputAt.value.style.top =
      position.value.top - MessageInputAt.value.clientHeight + "px";
  }
);

const closeAt = () => {
  showAtList.value = false;
  showMemberList.value = allMemberList.value;
  position.value = {
    left: 0,
    top: 0,
  };
};

const selectItem = (index: number) => {
  if (TUIGlobal.selectItem) {
    TUIGlobal.selectItem(index);
  } else {
    if (showMemberList?.value?.length) {
      const item = showMemberList?.value[index];
      emits("insertAt", {
        id: (item as any)?.userID,
        label: (item as any)?.nick || (item as any)?.userID,
      });
    }
  }
  closeAt();
};

const handleMemberAvatar = (item: any) => {
  return (
    (item as any)?.avatar ||
    "https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png"
  );
};

const handleMemberName = (item: any) => {
  return (item as any)?.nick ? (item as any)?.nick : (item as any)?.userID;
};

return { __sfc: true,emits, MessageInputAt, memberListItems, showAtList, memberList, allMemberList, showMemberList, isGroup, position, selectedIndex, isH5, isPC, currentConversationID, all, toggleAtList, handleAtListPosition, setCurrentSelectIndex, setShowMemberList, closeAt, selectItem, handleMemberAvatar, handleMemberName, TUITranslateService, BottomPopup }
}

})